var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('path',{attrs:{"d":"M7 10l5 5 5-5z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }